import { toRefs, computed } from 'vue';
import tinycolor from 'tinycolor2';
import ProfileEmbedContainer from './component-lib.esm3.js';
import ProfileLinkWrapper from '../component-lib.esm4.js';
import { useLink } from '../component-lib.esm6.js';
import { LINK_PROPS } from '../component-lib.esm3.js';
import { useTheme } from '../../compositions/component-lib.esm7.js';
import { useEmbedOptions } from '../../compositions/component-lib.esm6.js';
import { EVENTS } from '../../config/component-lib.esm.js';

//
var script = {
  components: {
    ProfileEmbedContainer,
    ProfileLinkWrapper
  },
  props: {
    ...LINK_PROPS,
    /** Track the `video-playing` event continuously */
    trackVideoPlayEvents: Boolean
  },
  setup(props, _ref) {
    let {
      emit
    } = _ref;
    const {
      link
    } = toRefs(props);
    const theme = useTheme();
    const linkEmbedOptions = computed(() => {
      return link.value.embed_options;
    });
    const embedType = computed(() => {
      return linkEmbedOptions.value.embed_type;
    });
    const url = computed(() => link.value.url);
    const [isEmbedLink, embedOptions, embedId] = useEmbedOptions({
      embedType,
      url
    });
    const styles = computed(() => {
      // Make video container background a solid color
      let bgColor = theme.value.profile.btnBgColor;
      if (bgColor === 'transparent') bgColor = '#000';
      return {
        '--c-bg-color': tinycolor(bgColor).setAlpha(1).toString()
      };
    });
    const classes = computed(() => {
      return {
        'v-embed--remove-bg': linkEmbedOptions.value.remove_bg
      };
    });
    const loaderColor = computed(() => {
      if (linkEmbedOptions.value.remove_bg) return theme.value.profile.btnBgColor;
      return null;
    });
    function handleEvent(event) {
      emit('event', event);
      if (event === EVENTS.VIDEO_STARTED) emit('click');
    }
    const {
      id
    } = useLink(props, {
      emit
    });
    return {
      id,
      isEmbedLink,
      embedType,
      embedOptions,
      embedId,
      styles,
      classes,
      loaderColor,
      handleEvent
    };
  }
};
export { script as default };